module.exports = __webpack_public_path__ + "static/media/tianguis.d03e8b19.png";